import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuthStore } from '@/shared/auth/useAuthStore';
import { buildLogoutUrl } from '@/shared/auth/cognito';

export function LogoutPage() {
  const { _hydrated, idToken, refreshToken, clear } = useAuthStore((s) => ({
    _hydrated: s._hydrated,
    idToken: s.idToken,
    refreshToken: s.refreshToken,
    clear: s.clear,
  }));

  useEffect(() => {
    if (!_hydrated) return;

    // Came back from Cognito with no session — go home
    if (!idToken && !refreshToken) {
      window.location.replace('/');
      return;
    }

    // Clear memory + localStorage, then hand off to Cognito to invalidate its session
    clear();
    useAuthStore.persist.clearStorage();
    window.location.href = buildLogoutUrl();
  }, [_hydrated]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress color="primary" />
      <Typography variant="body1" color="text.secondary">
        Signing out…
      </Typography>
    </Box>
  );
}
